import React, { useState } from 'react'

import Link from '../components/link'
import useMenu from '../hooks/useMenu'
import menu_icon from '../images/menu.svg'
import styles from './menu-modal.module.css'
import Modal from './modal'
import Tab from './tab'
import Tabs from './tabs'

const MenuColumn = ({ column }) => {
  if (!column || !column.length) return ''

  return column.map((item, i) => (
    <div key={i} className={styles.item}>
      <div className="flex flex-row justify-between items-center">
        <h1 className={styles.itemHeader}>{item.name}</h1>
        <span className={styles.itemPrice}>{item.price}</span>
      </div>
      {item.description ? (
        <p className={styles.itemDescription}>{item.description}</p>
      ) : (
        ''
      )}
      {item.addons && item.addons.length ? (
        <div className="mt-2">
          {item.addons.map((addon, i) => (
            <div key={i} className="flex flex-row justify-between">
              <span className={styles.subitemName}>{addon.name}</span>
              <span className={styles.subitemPrice}>{addon.price}</span>
            </div>
          ))}
        </div>
      ) : (
        ''
      )}
      {item.subitems && item.subitems.length
        ? item.subitems.map((subitem, i) => (
            <div key={i} className="flex flex-row mt-4 justify-between">
              <span className={styles.subitemName}>{subitem.name}</span>
              <span className={styles.subitemPrice}>{subitem.price}</span>
            </div>
          ))
        : ''}
    </div>
  ))
}

const MenuCategory = ({ category }) => (
  <div className="my-8 flex flex-col lg:flex-row">
    <div className={`${styles.column}`}>
      <MenuColumn column={category.firstColumn} />
    </div>
    {category.secondColumn ? (
      <>
        <span className={styles.border} />
        <div className={`${styles.column}`}>
          <MenuColumn column={category.secondColumn} />
        </div>
      </>
    ) : (
      ''
    )}
    {category.thirdColumn ? (
      <>
        <span className={styles.border} />
        <div className={`${styles.column}`}>
          <MenuColumn column={category.thirdColumn} />
        </div>
      </>
    ) : (
      ''
    )}
  </div>
)

const MenuCollection = ({ collection }) => (
  <div className={`${styles.collectionContainer} py-8`}>
    <div className={styles.collectionHeader}>
      <div className="flex flex-row items-center justify-between md:justify-start">
        <h1 className={styles.collectionName}>{collection.name}</h1>
        <span className={styles.collectionPrice}>{collection.price}</span>
      </div>
      {collection.description ? (
        <p className={styles.collectionDescription}>{collection.description}</p>
      ) : (
        ''
      )}
    </div>
    <div className="flex flex-col md:flex-row flex-wrap">
      {collection.subitems && collection.subitems.length
        ? collection.subitems.map((subitem, i) => (
            <div key={i} className={styles.collectionItemWrapper}>
              <span className={styles.subitemName}>{subitem.name}</span>
              <p className={styles.subitemDescription}>{subitem.description}</p>
            </div>
          ))
        : ''}
    </div>
  </div>
)

export const MenuTemplate = ({ menu }) => (
  <>
    <div className="mt-6">
      <div
        className={`${styles.menuModalBody}`}
        dangerouslySetInnerHTML={{ __html: menu.bodyHtml }}
      />
    </div>
    <div>
      {menu.menuItems ? <MenuCategory category={menu.menuItems} /> : ''}
      {menu.collections && menu.collections.length
        ? menu.collections.map((c, i) => (
            <MenuCollection key={i} collection={c} />
          ))
        : ''}
    </div>
  </>
)

export const MenuModal = ({ open, handleClose, menuFile }) => {
  const menu = useMenu()
  const [tab, setTab] = useState(menu.length && menu[0].title)
  const onTabClick = tab => {
    setTab(tab)
  }

  return (
    <Modal open={open} handleClose={handleClose} className={styles.modal}>
      <div className="container p-4 md:p-8 lg:p-12">
        <div className="w-full flex flex-col items-center mb-6">
          <img
            className={styles.menuModalIcon}
            src={menu_icon}
            alt="menu_icon"
          />
          <h1 className={styles.menuModalHeader}>Menu</h1>
        </div>
        <Tabs className={styles.tabs}>
          {menu.map((m, i) => (
            <Tab
              key={i}
              title={m.title}
              isActive={m.title === tab}
              onClick={() => onTabClick(m.title)}
            >
              <MenuTemplate menu={m} />
            </Tab>
          ))}
        </Tabs>
        {menuFile && menuFile.publicURL ? (
          <div className="mt-6 flex justify-center">
            <Link className="btn-primary" to={menuFile.publicURL}>
              Download the Menu
            </Link>
          </div>
        ) : null}
      </div>
    </Modal>
  )
}

export default MenuModal
